import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { TickValueComponent } from '../../tick-value/tick-value.component';
import { IvtfSupplementationAction } from 'src/app/types/sheet-action-aggregate-graph.types';

@Component({
    selector: 'app-ivtf-supplementation-slot',
    templateUrl: './ivtf-supplementation-slot.component.html',
    styleUrl: './ivtf-supplementation-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IvtfSupplementationSlotComponent implements SheetSlotComponentBase {

	action!: IvtfSupplementationAction;
	value!: string | null;

	@Input('action') set updateAction(action: IvtfSupplementationAction | null) {
		this.action = action as IvtfSupplementationAction;
		this.value = this.action.dose?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}